import { X } from 'lucide-react'
import { Button } from '../ui/button'

type HeaderToolProps = {
    name: string
    onClose?: () => void
}

const HeaderTool = ({ name, onClose }: HeaderToolProps) => {
    return (
        <div className='border-b sticky top-0 z-20 flex items-center justify-between bg-neutral-100 dark:bg-neutral-900 px-4 py-3'>
            <p className='font-semibold tracking-wider'>{name}</p>
            <Button
                title='Đóng'
                onClick={onClose}
                variant={'secondary'}
                size={'icon'}
                className='rounded-full size-7 p-1.5 gap-0'
            >
                <X className='size-4' />
            </Button>
        </div>
    )
}

export default HeaderTool
